<app-banner></app-banner>

<app-services></app-services>

<app-technologies></app-technologies>

<app-about></app-about>

<app-contact></app-contact>